import { MedicalHistory } from '../patients/medical-history';
import { Patient } from '../patients/patient';
import { Symptom } from '../symptoms/symptom';
import { System } from '../systems/system';
import { Notes } from '../notes/note';
import { sortBy, flatten } from 'lodash';

const camelcaseKeysDeep = require('camelcase-keys-deep');

export class Visit {
  id: string;
  createdDate: string;
  updatedDate: string;
  household: string;
  patient: Patient;
  medicalHistory: MedicalHistory;
  provider: string;
  clinicLocation: string;
  providerNotes: string;
  historyReviewed: boolean;
  patientName: string;
  twilioRoom: string;
  patientTwilioToken: string;
  providerTwilioToken: string;
  primaryComplaint: string;
  complaintDuration: string;
  previouslyDiagnosed: boolean;
  consultationComplete: boolean;
  consultationStart: string;
  consultationFinish: string;
  dosespotUrl: string;
  symptoms: Symptom[];
  systems: System[];
  symptomNames: string;
  notes: Notes[];
  newNotes: any;
  providerReady: boolean;
  billingCodes: string[];
  status: string;
  completedStatuses: string[];
  nurseVisitAvailable: boolean;

  constructor(data: any) {
    data = camelcaseKeysDeep(data);

    this.id = data.id;
    this.createdDate = data.createdDate;
    this.updatedDate = data.updatedDate;
    this.household = data.household;
    if (data.patient && typeof data.patient === 'object') {
      this.patient = new Patient(data.patient);
    } else if (data.patient) {
      this.patient = new Patient({ id: data.patient });
    }
    if (data.medicalHistory && typeof data.medicalHistory === 'object') {
      this.medicalHistory = new MedicalHistory(data.medicalHistory);
    } else if (data.medicalHistory) {
      this.medicalHistory = new MedicalHistory({ id: data.medicalHistory });
    }
    this.provider = data.provider;
    this.providerNotes = data.providerNotes;
    this.historyReviewed = data.historyReviewed;
    this.patientName = data.patientName;
    this.twilioRoom = data.twilioRoom;
    this.patientTwilioToken = data.patientTwilioToken;
    this.providerTwilioToken = data.providerTwilioToken;
    this.primaryComplaint = data.primaryComplaint;
    this.complaintDuration = data.complaintDuration;
    this.previouslyDiagnosed = data.previouslyDiagnosed;
    this.consultationComplete = data.consultationComplete;
    this.consultationStart = data.consultationStart;
    this.consultationFinish = data.consultationFinish;
    this.dosespotUrl = data.dosespotUrl;
    this.symptoms = data.latestSymptoms && data.latestSymptoms.map((latestSymptom) => {
      if (latestSymptom && typeof (latestSymptom) === 'object') {
        return new Symptom(latestSymptom);
      } else {
        return new Symptom({ id: latestSymptom });
      }
    });

    if (this.symptoms) {
      let names = this.symptoms.map((symptom) => { return symptom.name; });
      this.symptomNames = names.filter(Boolean).join(', ');
    } else {
      this.symptoms = [];
    }
    if (data.providerNotes && typeof (data.providerNotes) === 'object') {
      let sortedNotes = sortBy(data.providerNotes, (note) => {
        return new Date(note.createdAt);
      });
      this.notes = flatten(sortedNotes.map((notes) => {
        let _notes = new Notes(notes);
        return _notes.notes;
      }));
    } else {
      this.notes = [];
    }

    this.systems = data.latestSystems && data.latestSystems.map((latestSystem) => {
      if (latestSystem && typeof (latestSystem) === 'object') {
        return new System(latestSystem);
      } else {
        return new System({ id: latestSystem });
      }
    });

    this.newNotes = []; // Reset the new notes array
    this.providerReady = data.providerReady;
    this.billingCodes = data.billingCodes;
    this.status = data.status;
    this.completedStatuses = data.completedStatus;
    this.nurseVisitAvailable = data.nurseVisitAvailable;
  }
}



// WEBPACK FOOTER //
// ./src/app/visits/visit.ts